import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';

export const CarouselSwiper = styled(Swiper)`
	/* .swiper {} */
	width: 100%;
	height: 100%;
	padding-left: 1rem !important;
	overflow: visible !important;
`;

export const CardTitleContainer = styled.div`
	position: relative;
	padding: 1rem 1.25rem 1.25rem;
	h3 {
		margin: 0;
		color: #fff;
		margin-bottom: 3px;
	}
	p {
		margin: 0;
		font-size: 12px;
		//text-transform: uppercase;
		color: var(--ion-color-light-shade);
	}
`;

export const CarouselSwiperSlide = styled(SwiperSlide)`
	/* .swiper-slide {} */
	width: 75% !important;

	&.swiper-more-results {
		position: relative;
		width: 140px !important;
		margin-right: 0 !important;
	}
`;

export const CarouselHeader = styled.header`
	margin-bottom: 1.5rem;
	padding: 1.5rem 1rem 0;

	display: flex;
	justify-content: space-between;
	align-items: center;
	border-top: 1px solid var(--ion-color-medium);

	ion-icon {
		font-size: 2.2rem;
		fill: #257226;//var(--ion-color-secondary);
	}
`;

export const CarouselContainer = styled.section`
	padding: 0 0 2rem;

	/* background-color: #B7B78A; */
`;

export const CarouselMeta = styled.p`
	color: #257226;//var(--ion-color-secondary);
	margin: 0;
	font-size: 12px;
	//text-transform: uppercase;
`;

export const ProgressBar = styled.div`
	width: calc(100% - 64px);
	height: 5px;
	margin: 20px 32px;
	padding: 0 32px;
	background-color: var(--ion-color-step-100);
	border-radius: 10px;
	position: relative;
	overflow: hidden;
`;

interface ProgressProps {
	$progress: string;
}

export const ProgressInner = styled.div`
	width: ${(props: ProgressProps) => {
		return props.$progress;
	}};
	background: #257226;//var(--ion-color-secondary);
	height: 5px;
	position: absolute;
	top: 0;
	left: 0;
	border-radius: 50px;
	transition: width 0.2s ease-out;
`;

export const MoreResultsCard = styled.div`
	min-height: 248px;
	margin: 53px 0;
	border-radius: 20px;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-right: 8px;
	background: var(--ion-color-step-100);

	ion-icon {
		font-size: 80px;
		fill: #257226;//var(--ion-color-secondary);
	}
`;
